import React from 'react';
import '../../../styles/userTesting/index.css';

/**
 * Empty state: minimal, one line and a ghost button (title and description
 * join as two sentences, never with a dash)
 */
function UTEmptyState({
  title,
  description,
  action,
  actionLabel
}) {
  return (
    <div className="ut-empty-state">
      <p className="ut-empty-state-text">
        {title}{description ? `. ${description}` : ''}
      </p>
      {action && actionLabel && (
        <button onClick={action} className="ut-btn ut-btn-ghost">
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default UTEmptyState;
